
    import {
      getAllStaff,
      createStaff,
      createAllStaff,
      updateStaff,
      deleteStaff
    } from "@/services/staff";

    const state = {
      staff: [],
      params: {activeOnly: true, requirementStatus: "All"},
      processed: false
    };

    const getters = {
      getStaff(state) {
        return state.staff;
      },
      getParams(state) {
        return state.params;
      },
      staffProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      setParams({ commit }, params){
        commit("SET_PARAMS", params);
      },
      fetchStaff({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllStaff(
              params
            )
              .then(response => {
                commit("SET_STAFF", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createStaff({ commit }, staff) {
          return new Promise((resolve, reject) => {
            createStaff(staff)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllStaff({ commit }, staff) {
          return new Promise((resolve, reject) => {
            createAllStaff(staff)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateStaff({ commit }, staff) {
          return new Promise((resolve, reject) => {
            updateStaff(staff)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteStaff({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteStaff(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_STAFF(state, data) {
        state.staff = data;
        state.processed = true;
      },
      SET_PARAMS(state, data) {
        state.params = data;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    